import { defaultEnvironment } from '@ckmk/angular';

export default {
  ...defaultEnvironment,
  FRONT_URL: 'https://ucie.testing.ckmk.be',
  ALLOWED_HOSTS: ['ucie.testing.ckmk.be'],
  API_TOKEN: 'U2FsdGVkX19rxV0CSdccC3pAEoCSvg1PPYEMxjT5JmpP+3lFivBjOOsTXi5x1a0H',
  API_URL: 'https://ucie.testing.ckmk.be/api',
  SITE_NAME: 'Umbrella SIE',
  ADMIN_HASH: 'azerty',
};
